export const TARGET_TYPES = {
  MainTarget: 'Main Target',
  ProductTarget: 'Product Target',
  MonthlyTargetLayered: 'Monthly Target - Layered',
  ProductTargetLayered: 'Product Target - Layered',
  MonthlyTargetPrerequistite: 'Monthly Target - Prerequisite',
  ProductTargetPrerequisite: 'Product Target - Prerequisite',
}
export const TARGET_TYPES_OPTIONS = {
  'Main Target': TARGET_TYPES.MainTarget,
  'Product Target': TARGET_TYPES.ProductTarget,
  'Monthly Layered Target': TARGET_TYPES.MonthlyTargetLayered,
  'Product Layered Target': TARGET_TYPES.ProductTargetLayered,
  'Monthly Prerequisite Target': TARGET_TYPES.MonthlyTargetPrerequistite,
  'Product Prerequisite Target': TARGET_TYPES.ProductTargetPrerequisite,
}
